import { Link } from "react-router-dom";
import { topics } from "@/mocks/movies";

export default function TopicSection() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <div className="mb-6">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <span className="h-5 w-1.5 rounded-full bg-accent-500 md:h-6"></span>
            主题专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            精选合集，按心情与场景挑选属于你的观影清单
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to="/category/all"
              className="group relative block h-52 cursor-pointer overflow-hidden rounded-lg border border-background-200/70 md:h-60"
            >
              <img
                src={topic.image}
                alt={`${topic.title} 专题封面`}
                title={`${topic.title} - 97视频`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
                  专题合集
                </span>
                <h3 className="mt-2 font-heading text-lg font-bold text-white md:text-xl">
                  {topic.title}
                </h3>
                <p className="mt-1 text-xs text-white/80 md:text-sm">{topic.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}